import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_SMD_BL: TStep[] = [
  {
    pageId: PageId.DOG_AGE_SMD_BL,
  },
  {
    pageId: PageId.DOG_SEX_SMD_BL,
  },
  {
    pageId: PageId.DOG_BREED_SMD_BL,
  },
  {
    pageId: PageId.URGE_SMD_BL,
  },
  {
    pageId: PageId.GOALS_SMD_BL,
  },
  {
    pageId: PageId.URGE_1_SMD_BL,
  },
  {
    pageId: PageId.AGRESSIVE_BEHAVIOR_SMD_BL,
  },
  {
    pageId: PageId.TRIGGERS_SMD_BL,
  },
  {
    pageId: PageId.URGE_2_SMD_BL,
  },
  {
    pageId: PageId.BEHAVIOR_ISSUES_SMD_BL,
  },
  {
    pageId: PageId.DOG_LISTEN_SMD_BL,
  },
  {
    pageId: PageId.COMMANDS_SMD_BL,
  },
  {
    pageId: PageId.EAT_OFF_THE_GROUND_SMD_BL,
  },
  {
    pageId: PageId.DOG_ACT_SMD_BL,
  },
  {
    pageId: PageId.DOG_OFF_AT_HOME_SMD_BL,
  },
  {
    pageId: PageId.PREPARE_SCREEN_SMD_BL,
  },
  {
    pageId: PageId.DOG_PROFILE_SMD_BL,
  },
  {
    pageId: PageId.HEAR_ABOUT_WOOFZ_SMD_BL,
  },
  {
    pageId: PageId.MANNERS_TO_BUILD_SMD_BL,
  },
  {
    pageId: PageId.FEEL_BETTER_SMD_BL,
  },
  {
    pageId: PageId.PREPARE_FLOW_SMD_BL,
  },
  {
    pageId: PageId.EMAIL_SMD_BL,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_SMD_BL,
  },
  {
    pageId: PageId.SCRATCH_SCREEN_SMD_BL,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_SMD_BL,
  },
  {
    pageId: PageId.CHAT_UPSELL_SMD_BL,
  },
  {
    pageId: PageId.UPSELL_SMD_BL,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_SMD_BL,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_SMD_BL,
  },
  {
    pageId: PageId.DOWNLOAD_SMD_BL,
  },
  {
    pageId: PageId.ACCOUNT_SMD_BL,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_SMD_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_SMD_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
